























import YellowLabel from '@/views/atoms/YellowLabel.vue'
export default
  components: {
    YellowLabel
  }

  beforeCreate: () ->
    document.querySelector('html').style.overflowY = "hidden"
  beforeDestroy: () ->
    document.querySelector('html').style.overflowY = "auto"

  methods: {
    go_close: (e) ->
      @$emit('go_close')
  }
